import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

import { useScreenSize } from '../hooks/use-screen-size';
import { cn } from '../lib/utils';

export type Orientation = 'horizontal' | 'vertical';

function Separator({ ref, className, orientation = 'horizontal', decorative = true, ...props }: React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & { ref?: React.RefObject<React.ElementRef<typeof SeparatorPrimitive.Root> | null> }) {
    return (
        <SeparatorPrimitive.Root
            ref={ref}
            decorative={decorative}
            orientation={orientation}
            className={cn(
                'shrink-0 bg-border',
                orientation === 'horizontal'
                    ? 'h-[1px] w-full'
                    : 'h-full w-[1px]',
                className,
            )}
            {...props}
        />
    );
}
Separator.displayName = SeparatorPrimitive.Root.displayName;

export type ResponsiveSeparatorProps = {
    mobileOrientation?: Orientation;
    tabletOrientation?: Orientation;
    desktopOrientation?: Orientation;
};

function ResponsiveSeparator({ ref, ...props }: ResponsiveSeparatorProps & React.ComponentPropsWithoutRef<typeof Separator> & { ref?: React.RefObject<React.ElementRef<typeof Separator> | null> }) {
    const { size } = useScreenSize();

    let orientation: Orientation = 'horizontal';

    switch (size) {
        case 'mobile':
            orientation = props.mobileOrientation || 'horizontal';
            break;
        case 'tablet':
            orientation = props.tabletOrientation || 'horizontal';
            break;
        case 'desktop':
            orientation = props.desktopOrientation || 'horizontal';
            break;
    }

    return <Separator ref={ref} orientation={orientation} {...props} />;
}

export { ResponsiveSeparator, Separator };
